import type { AxModelInfo } from '../types.js';

import { AxAIDeepSeekModel } from './types.js';

export const axModelInfoDeepSeek: AxModelInfo[] = [
  {
    name: AxAIDeepSeekModel.DeepSeekV4Flash,
    currency: 'USD',
    aliases: [
      AxAIDeepSeekModel.DeepSeekChat,
      AxAIDeepSeekModel.DeepSeekReasoner,
    ],
    promptTokenCostPer1M: 0.14,
    completionTokenCostPer1M: 0.28,
    cacheReadTokenCostPer1M: 0.0028,
    contextWindow: 1_000_000,
    maxTokens: 384_000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: false,
    },
  },
  {
    name: AxAIDeepSeekModel.DeepSeekV4Pro,
    currency: 'USD',
    promptTokenCostPer1M: 0.435,
    completionTokenCostPer1M: 0.87,
    cacheReadTokenCostPer1M: 0.003625,
    contextWindow: 1_000_000,
    maxTokens: 384_000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: false,
    },
  },
];
